export default {
    props: {
        columns: {
            type: Array,
            required: true,
        },
        value: {
            type: Array,
            default: () => {
                return []
            }
        },
        defaultSortColumn: {
            type: Object
        },
        defaultSortDirection: {
            type: String,
            default: 'asc'
        },
    },
    data() {
        return {
            sortOrder: this.defaultSortDirection,
            sortedColumn: this.defaultSortColumn || this.columns[0],
            selectedAllRows: false,
        }
    },
    computed: {
        isSortAsc() {
            return this.sortOrder === 'asc'
        },
        isSortDesc() {
            return this.sortOrder === 'desc'
        },
        isEmpty() {
            return this.value.length < 1
        },
        numberOfRows() {
            return this.value.length
        },
        selectedRows() {
            return this.value.filter(r => r.selected === true)
        },
        numberOfSelectedRows() {
            return this.selectedRows.length
        },
    },
    watch: {
        value(newValue, oldValue) {
            if (newValue.length === oldValue.length) {
                this.$emit('selected-all', this.selectedAllRows)
            } else {
                this.selectedAllRows = false
            }
        },
    },
    methods: {
        isSortable(column) {
            return column.sortable !== false
        },
        sortByColumn(column) {
            if (! this.isSortable(column)) {
                return
            }

            if (column === this.sortedColumn) {
                this.sortOrder = (this.sortOrder === 'asc') ? 'desc' : 'asc'
            } else {
                this.sortedColumn = column
                this.sortOrder = 'asc'
            }

            this.$emit('sort', {column: this.sortedColumn, direction: this.sortOrder})
        },
        selectRow(row) {
            const index = this.value.findIndex(r => r === row)

            const rows = this.value.map((r, i) => {
                if (i === index) {
                    r.selected = r.selected ? false : true
                }

                return r
            })

            this.selectedAllRows = this.value.filter(r => r.selected === true).length === this.value.length

            this.$emit('input', rows)
        },
        selectAllRows() {
            this.selectedAllRows = !this.selectedAllRows

            const rows = this.value.map(r => {
                r.selected = this.selectedAllRows

                return r
            })

            this.$emit('input', rows)
            this.$emit('selected-all', this.selectedAllRows)
        },
        removeRow(row) {
            this.$emit('remove', row)
            this.$emit('input', this.value.filter(r => r !== row))
        }
    },
    render() {
        return this.$scopedSlots.default({
            columns: this.columns,
            defaultSortColumn: this.defaultSortColumn,
            defaultSortDirection: this.defaultSortDirection,
            isSortAsc: this.isSortAsc,
            isSortDesc: this.isSortDesc,
            isSortable: this.isSortable,
            sortedColumn: this.sortedColumn,
            sortByColumn: this.sortByColumn,
            rows: this.value,
            removeRow: this.removeRow,
            isEmpty: this.isEmpty,
            numberOfRows: this.numberOfRows,
            selectRow: this.selectRow,
            selectAllRows: this.selectAllRows,
            selectedAllRows: this.selectedAllRows,
            numberOfSelectedRows: this.numberOfSelectedRows,
            selectedAllAttrs: {
                value: this.selectedAllRows,
                checked: this.selectedAllRows,
            },
            selectedAllEvents: {
                input: (e) => { this.selectedAllRows = e.target.value === "true" ? true : false },
                change: (e) => {
                    this.selectAllRows()
                }
            }
        })
    },
}
